const projects = [
  {
    id: 1,
    title: 'Portfolio Site',
    description: 'ReactとモダンCSSを使用したレスポンシブなポートフォリオサイト。',
    longDescription: '個人のスキルや作品を紹介するポートフォリオサイトです。React、CSS Grid/Flexbox、Intersection Observer APIを使用し、モダンなアニメーションとユーザビリティを重視した設計になっています。',
    technologies: [
      { name: 'React' },
      { name: 'Tailwind CSS' }
    ],
    category: 'web',
    startDate: '2024-10-01',
    endDate: '2024-10-08',
    image: '/images/portfolioProject.png',
    images: ['/images/portfolioProject.png'],
    link: '#',
    githubUrl: 'https://github.com/yabu1121/PortfolioSite.git',
    demoUrl: '/',
    features: [],
    isActive: true,
    priority: 1,
  },
  {
    id: 2,
    title: 'Next Todo',
    description: 'Udemyで学習したReactベースのTodoアプリケーション。',
    longDescription: 'React Hooksを使用したシンプルなTodoアプリケーション。ローカルストレージでのデータ永続化、フィルタリング機能、レスポンシブデザインを実装しています。',
    technologies: [
      { name: 'Next.js' },
      { name: 'Tailwind CSS' }
    ],
    category: 'web',
    startDate: '2024-09-30',
    endDate: '2024-09-30',
    image: '/images/nextTodoProject.png',
    images: ['/images/nextTodoProject.png'],
    link: 'https://next-tasks-pink.vercel.app',
    githubUrl: 'https://github.com/yabu1121/next-tasks.git',
    demoUrl: 'https://next-tasks-pink.vercel.app',
    features: [],
    isActive: true,
    priority: 2,
  },
  {
    id: 3,
    title: 'Order System',
    description: 'カフェをモチーフにレシートまで出すアプリケーション',
    longDescription: 'フロントエンドだけですが実装をしています',
    technologies: [
      { name: 'TypeScript' },
      { name: 'Next.js' }
    ],
    category: 'web',
    startDate: '2025-10-01',
    endDate: '2025-10-01',
    image: '/images/orderSystemProject.png',
    images: ['/images/orderSystemProject.png'],
    link: 'https://order-system-pink.vercel.app',
    githubUrl: 'https://github.com/yabu1121/order-system.git',
    demoUrl: 'https://order-system-pink.vercel.app',
    features: [],
    isActive: true,
    priority: 3,
  },{
    id: 4,
    title: '電卓',
    description: '電卓をNext.jsで実装しました',
    longDescription: '簡単な機能のみですが、今後は関数電卓にできるように学習を進めていきます',
    technologies: [
      { name: 'TypeScript' },
      { name: 'Next.js' },
      { name: 'Tailwind Css' }
    ],
    category: 'web',
    startDate: '2025-10-15',
    endDate: '2025-10-15',
    image: '/images/calculator.png',
    images: ['/images/calculator.png'],
    link: 'https://calculator-4mpe.vercel.app/',
    githubUrl: 'https://github.com/yabu1121/calculator.git',
    demoUrl: 'https://calculator-4mpe.vercel.app/',
    features: [],
    isActive: true,
    priority: 3,
  },{
    id: 5,
    title: 'mailer',
    description: 'コンタクトフォームを自分のメールに送信できるようにしました。',
    longDescription: '後日このポートフォリオサイトのコンタクトもこれにします',
    technologies: [
      { name: 'TypeScript' },
      { name: 'Next.js' },
      { name: 'Bootstrap' }
    ],
    category: 'web',
    startDate: '2025-10-20',
    endDate: '2025-10-20',
    image: '/images/mailer.png',
    images: ['/images/mailer.png'],
    link: 'https://mailer-ten-tawny.vercel.app',
    githubUrl: 'https://github.com/yabu1121/mailer.git',
    demoUrl: 'https://mailer-ten-tawny.vercel.app',
    features: [],
    isActive: true,
    priority: 3,
  },
  {
    id: 6,
    title: 'blog',
    description: 'Udemyを参考に作りました',
    longDescription: 'データベース連携もできています',
    technologies: [
      { name: 'Authjs' },
      { name: 'Next.js' },
      { name: 'shadcn' },
      { name: 'supabase' },
    ],
    category: 'web',
    startDate: '2025-10-24',
    endDate: '2025-10-24',
    image: '/images/blog.png',
    images: ['/images/blog.png'],
    link: 'https://blog-app-pu5r.vercel.app',
    githubUrl: 'https://github.com/yabu1121/blog-app',
    demoUrl: 'https://blog-app-pu5r.vercel.app',
    features: [],
    isActive: true,
    priority: 3,
  }
];

export const getActiveProjects = () => {
  return projects.filter(project => project.isActive);
};


export const getInProgressProjects = () => {
  return getActiveProjects().filter(project => project.status === 'in-progress');
};


export const getProjectsByCategory = (category) => {
  return getActiveProjects().filter(project => project.category === category);
};

export const getProjectsByTechnology = (technology) => {
  return getActiveProjects().filter(project =>
    project.technologies.some(tech =>
      tech.name.toLowerCase().includes(technology.toLowerCase())
    )
  );
};

export const getSortedProjects = () => {
  return getActiveProjects().sort((a, b) => {
    const priorityCompare = a.priority - b.priority;
    if (priorityCompare !== 0) return priorityCompare;
    return new Date(b.endDate || 0) - new Date(a.endDate || 0);
  });
};

export default projects;